module.exports = __webpack_public_path__ + "img/hero-2.b66d5f45.jpg";